






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MImageMarkerMagnifier extends Vue {
  @Prop({ required: true }) src!: string;
  @Prop({ required: true }) imageDimensions!: { width: number; height: number };
  @Prop({ default: false }) deactivated!: boolean;
  @Prop({ default: 4 }) zoomFactor!: number;

  isVisible = false;
  size = 200;
  position = { x: 0, y: 0, xOffset: -1 };
  localPosition = { x: 0, y: 0 };

  get style() {
    return {
      position: "absolute",
      top: `${this.position.y - this.size / 2}px`,
      left: `${this.position.x - (this.position.xOffset * this.size) / 2}px`,
      width: `${this.size}px`,
      height: `${this.size}px`,
      borderRadius: "50%",
      border: "3px solid #ccc",
      boxShadow: "0 0 5px #000",
      pointerEvents: "none",
      backgroundColor: "#fff",
      backgroundImage: `url(${this.src})`,
      backgroundSize: `${this.imageDimensions.width * this.zoomFactor}px ${this.imageDimensions.height *
        this.zoomFactor}px`,
      backgroundRepeat: "no-repeat",
      backgroundPositionX: `${-(this.localPosition.x * this.zoomFactor - this.size / 2)}px`,
      backgroundPositionY: `${-(this.localPosition.y * this.zoomFactor - this.size / 2)}px`
    };
  }

  show() {
    if (this.deactivated) return;
    this.isVisible = true;
  }

  hide() {
    this.isVisible = false;
  }

  updateMagnifierPosition(event: MouseEvent | TouchEvent, imageElement: HTMLElement | null) {
    if (!this.isVisible || this.deactivated) return;
    const rect = imageElement?.getBoundingClientRect();
    if (!rect) return;

    let mouseXPos = 0;
    let mouseYPos = 0;
    let xAbsolut = 0;

    if (event instanceof MouseEvent) {
      xAbsolut = event.clientX;
      mouseXPos = event.clientX - rect.left;
      mouseYPos = event.clientY - rect.top;
    } else if (event instanceof TouchEvent && event.touches.length > 0) {
      xAbsolut = event.touches[0].clientX;
      mouseXPos = event.touches[0].clientX - rect.left;
      mouseYPos = event.touches[0].clientY - rect.top;
    }

    this.position.x = mouseXPos;
    this.position.y = mouseYPos;

    this.localPosition.x = Math.max(0, Math.min(mouseXPos, this.imageDimensions.width));
    this.localPosition.y = Math.max(0, Math.min(mouseYPos, this.imageDimensions.height));

    const windowWidth = window.innerWidth;
    if (windowWidth / 2 < 200) {
      this.size = windowWidth / 2 - 10;
    } else {
      this.size = 200;
    }

    if (xAbsolut < windowWidth / 2) {
      this.position.xOffset = -1;
    } else {
      this.position.xOffset = 1;
    }
  }
}
